import { hasMessage } from '@/lib/utils';
import {
  useChatData,
  useChatInteract,
  useChatMessages
} from '@chainlit/react-client';

import MaterialIcon from '@/components/MaterialIcon';

interface SubmitButtonProps {
  disabled?: boolean;
  onSubmit: () => void;
}

export default function SubmitButton({
  disabled,
  onSubmit
}: SubmitButtonProps) {
  const { loading } = useChatData();
  const { messages, firstInteraction } = useChatMessages();
  const { stopTask } = useChatInteract();

  const showStop = loading && firstInteraction && hasMessage(messages);

  if (showStop) {
    return (
      <button
        id="stop-button"
        onClick={stopTask}
        className="bg-primary text-background p-2 min-h-9 min-w-9 rounded-full hover:bg-primary-hover active:scale-[0.97] transition-all flex items-center justify-center shadow-lg cursor-pointer"
      >
        <MaterialIcon name="stop" className="font-bold" />
      </button>
    );
  }

  return (
    <button
      id="chat-submit"
      disabled={disabled}
      onClick={onSubmit}
        className="bg-primary text-background p-2 min-h-9 min-w-9 rounded-full hover:bg-primary-hover active:scale-[0.97] transition-all flex items-center justify-center shadow-lg cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed"
    >
      <MaterialIcon name="arrow_upward" className="font-bold" />
    </button>
  );
}
